<header>
  <div class="card-wrapper">
    <mat-card *ngIf="app.state.error" class="error">
      <h2>Technische Störung</h2>
      <div [innerHTML]="app.state.error">

      </div>
    </mat-card>

    <mat-card *ngIf="app.state.maintenance" class="maintenance">
      <h2>Wartungsarbeiten</h2>
      <div [innerHTML]="app.state.maintenance">

      </div>
    </mat-card>

    <mat-card class="logo">
      <a href="https://www.staatsanzeiger.de"></a>
    </mat-card>


  </div>
</header>

<nav *ngIf="authed" class="{{ sideNavActive ? 'active': '' }}">
  <mat-card class="nav">
    <button mat-button (click)="sideNav.toggle(); sideNavActive = !sideNavActive" class="menu">
      <fa-icon [icon]="['fas', 'bars']" size="lg" class="burger"></fa-icon>
      <fa-icon [icon]="['fas', 'times']" size="lg" class="close"></fa-icon>
    </button>
    <h3>{{user.name}}</h3><br>
    <p>{{user.email}}</p>
    <fa-icon [icon]="['fas', 'user']" size="lg" class="float-right"></fa-icon>
  </mat-card>
</nav>

<div class="main">
  <mat-drawer-container class="container" hasBackdrop="false">
    <mat-drawer #sideNav class="side-nav" mode="over" autoFocus="false">
      <div (click)="sideNav.toggle(); sideNavActive = !sideNavActive">
        <ng-container *ngIf="app.domainAdmins && app.domainAdmins.length">
          <button mat-menu-item routerLink="nutzer-verwaltung">
            <fa-icon [icon]="['fas', 'users-cog']"></fa-icon>
            <span>Verwaltung von Mitarbeiterzugängen</span>
          </button>
        </ng-container>
        <button mat-menu-item routerLink="zugaenge">
          <fa-icon [icon]="['fas', 'users-cog']"></fa-icon>
          <span>Zugänge verwalten</span>
        </button>
        <button mat-menu-item routerLink="profil">
          <fa-icon [icon]="['fas', 'pen']"></fa-icon>
          <span>Profil bearbeiten</span>
        </button>
        <button mat-menu-item routerLink="neue-email">
          <fa-icon [icon]="['fas', 'at']"></fa-icon>
          <span>E-Mail-Adresse ändern</span>
        </button>
        <button mat-menu-item (click)="newPassword()">
          <fa-icon [icon]="['fas', 'key']"></fa-icon>
          <span>Passwort ändern</span>
        </button>
        <button mat-menu-item (click)="logout()">
          <fa-icon [icon]="['fas', 'sign-out-alt']"></fa-icon>
          <span>Abmelden</span>
        </button>
      </div>
    </mat-drawer>

    <router-outlet></router-outlet>

  </mat-drawer-container>
</div>

<footer>
  <mat-card>
    <mat-grid-list cols="9" rowHeight="50px">
      <mat-grid-tile colspan="4" class="copyright">
        <span>&copy;</span>
        2025 - Staatsanzeiger für <br>Baden-Württemberg GmbH &amp; Co. KG
      </mat-grid-tile>
      <mat-grid-tile colspan="2"><a href="https://www.staatsanzeiger.de/impressum" target="_blank">Impressum</a>
      </mat-grid-tile>
      <mat-grid-tile colspan="2"><a href="https://www.staatsanzeiger.de/datenschutz" target="_blank">Datenschutz</a>
      </mat-grid-tile>
      <mat-grid-tile><a href="https://www.staatsanzeiger.de/agb" target="_blank">AGB</a></mat-grid-tile>
    </mat-grid-list>
  </mat-card>
</footer>
